import Fetch from "@/utils/Fetch";
import { ManagerMeeting, ResultResponse } from "@/interfaces/api/models";

/**
 * HubSpot meetings for the signed-in company, synced through Manager and always fetched afresh.
 * A Manager failure comes back as an empty list, not an error.
 */
const getMeetings = async (): Promise<ResultResponse<ManagerMeeting>> => {
    return await Fetch.get({
        url: "/Meeting/List",
    });
};

export default {
    getMeetings,
};
